import React, { useMemo } from 'react'
import { Button, Modal, Table } from '@themesberg/react-bootstrap'

const numberFormatter = new Intl.NumberFormat('vi-VN')

const formatMoney = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  const amount = Number(value)
  if (!Number.isFinite(amount)) return '—'
  return `${numberFormatter.format(amount)} đ`
}

const formatCount = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  const count = Number(value)
  if (!Number.isFinite(count)) return '—'
  return numberFormatter.format(count)
}

const PRIZE_ROWS = {
  mega: [
    { label: 'Jackpot', hint: '6 số', valueKey: 'jackpotPrize1', winnerKey: 'jackpot1Winner' },
  ],
  power: [
    { label: 'Jackpot 1', hint: '6 số', valueKey: 'jackpotPrize1', winnerKey: 'jackpot1Winner' },
    { label: 'Jackpot 2', hint: '5 số + số đặc biệt', valueKey: 'jackpotPrize2', winnerKey: 'jackpot2Winner' },
  ],
  lotto535: [
    { label: 'Jackpot', hint: '5 số + số đặc biệt', valueKey: 'jackpotPrize1', winnerKey: 'jackpot1Winner' },
    { label: 'Giải Nhất', hint: '5 số', valueKey: 'prize1Value', winnerKey: 'prize1Winner' },
    { label: 'Giải Nhì', hint: '4 số + số đặc biệt', valueKey: 'prize2Value', winnerKey: 'prize2Winner' },
    { label: 'Giải Ba', hint: '4 số', valueKey: 'prize3Value', winnerKey: 'prize3Winner' },
    { label: 'Giải Tư', hint: '3 số + số đặc biệt', valueKey: 'prize4Value', winnerKey: 'prize4Winner' },
    { label: 'Giải Năm', hint: '3 số', valueKey: 'prize5Value', winnerKey: 'prize5Winner' },
    { label: 'Giải khuyến khích', hint: 'Cố định', value: 10000, winner: null },
  ],
}

function parseDrawNumbers(result, hasSpecial) {
  const raw = Array.isArray(result) && result[0] ? String(result[0]) : ''
  const tokens = raw.split(/\s+/).filter(Boolean)
  if (!hasSpecial || tokens.length === 0) {
    return tokens.map((n) => ({ n, special: false }))
  }
  const last = tokens.pop()
  const specials = last.split('|').filter(Boolean)
  return [
    ...tokens.map((n) => ({ n, special: false })),
    ...specials.map((n) => ({ n, special: true })),
  ]
}

const NumberBall = ({ n, special }) => (
  <span
    style={{
      width: 44,
      height: 44,
      borderRadius: '50%',
      border: `2px solid ${special ? '#dc3545' : '#faa61a'}`,
      color: special ? '#dc3545' : '#c47d00',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      margin: 4,
      fontSize: 16,
    }}
  >
    {n}
  </span>
)

export default function ResultDetailPopup({ show, onHide, game, row }) {
  const hasSpecial = game === 'power' || game === 'lotto535'
  const numbers = useMemo(() => parseDrawNumbers(row?.result, hasSpecial), [row, hasSpecial])
  const prizes = PRIZE_ROWS[game] || []
  const period = row?.gamePeriod
  const sharedJackpot = row?.isSharedJackpot === 1 || period?.isSharedJackpot === 1

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {period ? `Kết quả kỳ #${period.name}` : 'Kết quả kỳ quay'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {period && (
          <div className="mb-3">
            <div>{period.resultDate} <span className="text-info">{period.resultTime}</span></div>
            {sharedJackpot && <div className="text-danger">Kỳ chia giải thưởng</div>}
          </div>
        )}
        <div className="d-flex flex-wrap justify-content-center mb-2">
          {numbers.map((item, index) => (
            <NumberBall key={`${item.n}-${index}`} n={item.n} special={item.special} />
          ))}
        </div>
        {hasSpecial && (
          <div className="text-center text-muted mb-3" style={{ fontSize: 13 }}>
            Số màu đỏ là số đặc biệt
          </div>
        )}
        <Table bordered responsive className="align-middle mb-0">
          <thead className="thead-light">
            <tr>
              <th>Giải</th>
              <th>Cách trúng</th>
              <th className="text-end">Giá trị</th>
              <th className="text-end">Số người trúng</th>
            </tr>
          </thead>
          <tbody>
            {prizes.map((prize) => (
              <tr key={prize.label}>
                <td><b>{prize.label}</b></td>
                <td>{prize.hint}</td>
                <td className="text-end text-success">
                  {formatMoney(prize.valueKey ? row?.[prize.valueKey] : prize.value)}
                </td>
                <td className="text-end">
                  {prize.winnerKey ? formatCount(row?.[prize.winnerKey]) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onHide}>Đóng</Button>
      </Modal.Footer>
    </Modal>
  )
}
